import { createEventHook } from '@vueuse/core';

export interface OnBlockTreeSlotClickPayload {
	childId: string;
	slotName: string;
}

export function useBlockEditorTree() {
	const slotClickEvent = createEventHook<OnBlockTreeSlotClickPayload>();

	return {
		slotClickEvent,
	};
}

export type BlockEditorTree = ReturnType<typeof useBlockEditorTree>;
